<template>
  <v-card
    elevation="3"
  >
    <v-card-title class="d-flex justify-space-between align-start mb-0 pb-3">
      <div>
        <h2>Client details</h2>
        <v-breadcrumbs
          class="mb-0 pb-0 ml-0 pl-0 pt-1"
          :items="breadcrumbs"
        />
      </div>
    </v-card-title>
    <v-card-text>
      <v-row class="mt-3">
        <v-col>
          <div class="header-player">
            <v-avatar
              color="primary"
              size="80"
            >
              <img
                v-if="player.avatar"
                :src="player.avatar"
              >
            </v-avatar>
            <div class="player-name">
              <h1>{{ player.name }}</h1>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12">
          <h3>Main info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Сountry</td>
              <td>{{ player.country_name || '-' }}</td>
            </tr>
            <tr>
              <td>Time zone</td>
              <td>{{ player.timezone_name || '-' }}</td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12">
          <h3>Messengers</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Teleggram</td>
              <td>{{ player.telegram || '-' }}</td>
            </tr>
            <tr>
              <td>Discord</td>
              <td>{{ player.discord || '-' }}</td>
            </tr>
          </table>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import clientsAPI from '../../api/clients';

export default {
  data: () => ({
    loading: {
      init: false,
    },

    player: {},

    breadcrumbs: [
      { text: 'Clients list', to: '/clients/list' },
      { text: 'Details', disabled: true },
    ],
  }),

  created() {
    this.init();
  },

  methods: {
    init() {
      this.loading.init = true;
      const { id } = this.$route.params;
      clientsAPI.details(id)
        .then((response) => {
          if (response.data.success) {
            this.player = response.data.data.player;
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-player {
  display: flex;
  align-items: center;
}

h3 {
  color: #000;
  margin-bottom: 5px;
}

.player-name {
  margin-left: 20px;

  h1 {
    color: #000;
    font-size: 28px;
    margin-bottom: 5px;
  }

  span {
    font-size: 18px;
  }
}

.info-user-tbl {
  td {
    padding: 5px 0;
    font-size: 16px;

    &:first-child {
      font-weight: bold;
      padding-right: 20px;
    }
  }
}
</style>
